import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import axiosService from '../../../../utils/AxiosService'
import { BuildingFill, ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import SidebarFoldersList from './SidebarFoldersList'
import { useNavigate, useParams } from 'react-router-dom'
import { BrowseContext } from '../../../../contexts/BrowseContext'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'

export default observer(function ClientsItem({ client }) {
  const { browseState } = useContext(BrowseContext)
  const { client_id } = useParams()
  const [isSelected, setIsSelected] = useState(false)
  const [hoverClient, setHoverClient] = useState(false)
  const [folders, setFolders] = useState([])
  const [showTooltip, setShowTooltip] = useState(false)
  const navigate = useNavigate()
  const { isCollapsed } = useSidebarCollapse()

  const getFolders = () => {
    axiosService
      .get(`/api/project_manager/clients/${client.id}/folders`,
        {
          params:
          {
            filter: browseState.resultsFilter,
            sort_by: browseState.folderListSort.attribute,
            decending: browseState.folderListSort.direction
          }
        }
      )
      .then(resp => setFolders(resp))
      .catch(error => console.log(error))
  }

  const handleClick = () => {
    setIsSelected(!isSelected)
    setHoverClient(true)
    if (!isSelected) getFolders()
    isSelected ? navigate('/project_manager/campaigns') : navigate(`/project_manager/campaigns/clients/${client.id}`)
  }

  useEffect(() => {
    if(+client_id === +client.id) {
      setIsSelected(true)
      setHoverClient(true)
      getFolders()
    } else {
      setIsSelected(false)
      setHoverClient(false)
      setFolders([])
    }
  }, [client, client_id])

  return (
    <div className="relative">
      <button
        onMouseEnter={() => {
          setHoverClient(true)
          if (isCollapsed) setShowTooltip(true)
        }}
        onMouseLeave={() => {
          if (isSelected && !isCollapsed) return
          setHoverClient(false)
          setShowTooltip(false)
        }}
        className={`flex ${isCollapsed ? 'justify-center' : 'justify-between'} items-center w-full rounded-lg py-1 px-2 ${hoverClient ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''}`}
        onClick={() => handleClick() }
      >
        <div className={`flex ${isCollapsed ? '' : 'gap-3'} items-center`}>
          <BuildingFill className="rb-text-muted" style={{ color: hoverClient ? client.theme_color : undefined }} />
          {!isCollapsed && <span className='truncate max-w-[120px] dark:text-white'>{client.name}</span>}
        </div>
        {!isCollapsed && client.folder_count > 0 && (isSelected ? <ChevronUp className="dark:text-white" /> : <ChevronDown className="dark:text-white" />)}
      </button>
      {isCollapsed && showTooltip && (
        <div className="absolute left-full ml-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-md whitespace-nowrap z-50 shadow-lg pointer-events-none">
          {client.name}
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900 dark:border-r-gray-700"></div>
        </div>
      )}
      { folders.length > 0 && isSelected && !isCollapsed && <SidebarFoldersList folders={folders} /> }
    </div>
  )
})
